/** Decimal string tutarlar için kuruş (BigInt) aritmetiği; float kullanılmaz. Çekirdek fonksiyonlar ortak modülde. */
import { cents, toMoney } from '@/lib/money'

export { cents, toMoney }

export const sumMoney = (list: string[]) => toMoney(list.reduce((acc, m) => acc + cents(m), 0n))
